<div class="di">
    <H1>リダイレクト</H1>
</div>
